import m2 from './files/soundshare.png'
import music_app_design from './files/User_friendly_Music_sharing_App_Design.pdf'
import journeymap from './files/searching.png'
import Searching_Behaviors from './files/Searching_Behaviors.pdf'
import './Projects.css'
import datasetWebprog from './files/dataset.png'
import protea_photo from './files/proteaWorkshop.png'
import Mondrian from './files/Mondrian.png'
import VizCode from './files/VizCode__A_Practical_Real_time_Tool_for_In_Class_Computer_Programming_Tutoring.pdf'
import VizCode_demo_photo from './files/vizcode_demo_photo.png'
import spark_photo from './files/spark.png'
// import spark_thesis from './files/Thesis.pdf'
// import spart_preprint from './files/SPARK_preprint.pdf'
import glitter_photo from './files/glitter.png'
import glitter_paper from './files/glitter_paper.pdf'
import spark_paper from './files/spark_paper.pdf'
import editrail_paper from './files/Editrail_paper.pdf'
import editrail_photo from './files/editrail_figure.png'
import codestream_photo from './files/codestream_figure.png'
import visar_deploy_paper from './files/visar_deploy_paper.pdf'
import visar_deploy_photo from './files/visar_deploy_figure.png'
import { useState } from "react"
import oversight_photo from './files/oversight.png'
import oversight_paper from './files/oversight_paper.pdf'
import CodeStream_paper from './files/CodeStream_paper.pdf'
const PrjTemplate = () => {
  const [copied, setCopied] = useState(false)
  return (
    <section className='whole_section'>
      <section className="section-row">
        <div className="section-left">
          <div className="section-image">
            <img src={codestream_photo} alt="CodeStream" />
          </div>
        </div>
        <div className="section-right">
          <div>
            <div className="section-title-large">
              <p className="section-position">
                CHI'26: Proceedings of the CHI Conference on Human Factors in Computing Systems</p>
              <p className="section-title">
                CodeStream: Augmenting Timelines with Code Annotation for Navigating Large Coding Histories
              </p>
              <p className="section-author">
                Ashley Ge Zhang, Yan-Ru Jhou, <span style={{
                  fontWeight: '600'
                }}>Yinuo Yang</span>, Shamita Rao, Maryam Arab, Yan Chen, Steve Oney</p>
            </div>
            <div className="read-more-card-mobile">
              <div className="card-closed">
                <a className="card" href={CodeStream_paper} target='_blank'>Paper</a>
                {/* <a href="https://inonnno.github.io/Academic-project-page-Spark/" target='_blank' className="card" >Project</a>
                <a href="https://peachlab.inf.ethz.ch/projects/spark/" target='_blank' className="card" >Website</a> */}
                {/* <a href="https://doi.org/10.48550/arXiv.2604.04918" target='_blank' className="card" >Arxiv</a> */}
                {/* <a href="https://doi.org/10.48550/arXiv.2604.04918" target='_blank' className="card" >DOI</a> */}
                {/* <a className="card" href={spart_preprint} target='_blank'>Preprint</a> */}
                {/* <span className="card" >Demo</span> */}
                {/* <span
                  className="card"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigator.clipboard.writeText(``)
                    setCopied(true)
                    setTimeout(() => setCopied(false), 1200)
                  }}
                >
                  {copied ? "Copied!" : "BibTeX"}
                </span> */}
              </div>
            </div>
          </div>
        </div>
      </section>

    </section>
  )
}

const Oversight = () => {
  const [copied, setCopied] = useState(false)
  return (
    <section className='whole_section'>
      <section className="section-row">
        <div className="section-left">
          <div className="section-image">
            <img src={oversight_photo} alt="Oversight" />
          </div>
        </div>
        <div className="section-right">
          <div>
            <div className="section-title-large">
              <p className="section-position">
                In Submission</p>
              <p className="section-title">
                Comparing Human Oversight Strategies for Computer-Use Agents</p>
              <p className="section-author">
                Chaoran Chen, Zhiping Zhang, Zeya Chen, Eryue Xu, <span style={{
                  fontWeight: '600'
                }}>Yinuo Yang</span>, Ibrahim Khalilov, Simret A Gebreegziabher, Yanfang Ye, Ziang Xiao, Yaxing Yao, Tianshi Li, Toby Jia-Jun Li
              </p>
            </div>
            <div className="read-more-card-mobile">
              <div className="card-closed">
                <a className="card" href={oversight_paper} target='_blank'>Paper</a>
                {/* <a href="https://inonnno.github.io/Academic-project-page-Spark/" target='_blank' className="card" >Project</a>
                <a href="https://peachlab.inf.ethz.ch/projects/spark/" target='_blank' className="card" >Website</a> */}
                <a href="https://doi.org/10.48550/arXiv.2604.04918" target='_blank' className="card" >Arxiv</a>
                {/* <a className="card" href={spart_preprint} target='_blank'>Preprint</a> */}
                {/* <span className="card" >Demo</span> */}
                <span
                  className="card"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigator.clipboard.writeText(`@misc{chen2026comparinghumanoversightstrategies,
      title={Comparing Human Oversight Strategies for Computer-Use Agents}, 
      author={Chaoran Chen and Zhiping Zhang and Zeya Chen and Eryue Xu and Yinuo Yang and Ibrahim Khalilov and Simret A Gebreegziabher and Yanfang Ye and Ziang Xiao and Yaxing Yao and Tianshi Li and Toby Jia-Jun Li},
      year={2026},
      eprint={2604.04918},
      archivePrefix={arXiv},
      primaryClass={cs.HC},
      url={https://arxiv.org/abs/2604.04918}, 
}`)
                    setCopied(true)
                    setTimeout(() => setCopied(false), 1200)
                  }}
                >
                  {copied ? "Copied!" : "BibTeX"}
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

    </section>
  )
}

const CodeStream = () => {
  const [copied, setCopied] = useState(false)
  return (
    <section className='whole_section'>
      <section className="section-row">
        <div className="section-left">
          <div className="section-image">
            <img src={codestream_photo} alt="CodeStream" />
          </div>
        </div>
        <div className="section-right">
          <div>
            <div className="section-title-large">
              <p className="section-position">
                CHI'26: Proceedings of the CHI Conference on Human Factors in Computing Systems</p>
              <p className="section-title">
                <strong>CodeStream</strong>: Augmenting Timelines with Code Annotation for Navigating Large Coding Histories
              </p>
              <p className="section-author">
                Ashley Ge Zhang, Yan-Ru Jhou, <span style={{
                  fontWeight: '600'
                }}>Yinuo Yang</span>, Shamita Rao, Maryam Arab, Yan Chen, Steve Oney</p>
            </div>
            <div className="read-more-card-mobile">
              <div className="card-closed">
                <a className="card" href={CodeStream_paper} target='_blank'>Paper</a>
                {/* <a href="https://inonnno.github.io/Academic-project-page-Spark/" target='_blank' className="card" >Project</a>
                <a href="https://peachlab.inf.ethz.ch/projects/spark/" target='_blank' className="card" >Website</a> */}
                {/* <a href="https://doi.org/10.48550/arXiv.2604.04918" target='_blank' className="card" >Arxiv</a> */}
                {/* <a href="https://doi.org/10.48550/arXiv.2604.04918" target='_blank' className="card" >DOI</a> */}
                {/* <a className="card" href={spart_preprint} target='_blank'>Preprint</a> */}
                {/* <span className="card" >Demo</span> */}
                {/* <span
                  className="card"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigator.clipboard.writeText(``)
                    setCopied(true)
                    setTimeout(() => setCopied(false), 1200)
                  }}
                >
                  {copied ? "Copied!" : "BibTeX"}
                </span> */}
              </div>
            </div>
          </div>
        </div>
      </section>

    </section>
  )
}
const VISAR_Deploy = () => {
  const [copied, setCopied] = useState(false)
  return (
    <section className='whole_section'>
      <section className="section-row">
        <div className="section-left">
          <div className="section-image">
            <img src={visar_deploy_photo} alt="Visar_Deploy" />
          </div>
        </div>
        <div className="section-right">
          <div>
            <div className="section-title-large">
              <p className="section-position">
                In Submission</p>
              <p className="section-title">
                Lessons from Real-World Deployment of a Cognition-Preserving Writing Tool: Students Actively Engage with Critical Thinking and Planning
              </p>
              <p className="section-author">
                <span style={{
                  fontWeight: '600'
                }}>Yinuo Yang*</span>, Zheng Zhang*, Ningzhi Tang, Xu Wang, Alex Ambrose, Nathaniel Myers, Patrick Clauss, Toby Jia-Jun Li
              </p>
            </div>
            <div className="read-more-card-mobile">
              <div className="card-closed">
                <a className="card" href={visar_deploy_paper} target='_blank'>Paper</a>
                {/* <a href="https://inonnno.github.io/Academic-project-page-Spark/" target='_blank' className="card" >Project</a>
                <a href="https://peachlab.inf.ethz.ch/projects/spark/" target='_blank' className="card" >Website</a> */}
                <a href="https://doi.org/10.48550/arXiv.2603.15777" target='_blank' className="card" >Arxiv</a>
                {/* <a className="card" href={spart_preprint} target='_blank'>Preprint</a> */}
                {/* <span className="card" >Demo</span> */}
                <span
                  className="card"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigator.clipboard.writeText(`@misc{yang2026lessonsrealworlddeploymentcognitionpreserving,
      title={Lessons from Real-World Deployment of a Cognition-Preserving Writing Tool: Students Actively Engage with Critical Thinking and Planning Affordances}, 
      author={Yinuo Yang and Zheng Zhang and Ningzhi Tang and Xu Wang and Alex Ambrose and Nathaniel Myers and Patrick Clauss and Toby Jia-Jun Li},
      year={2026},
      eprint={2603.15777},
      archivePrefix={arXiv},
      primaryClass={cs.HC},
      url={https://arxiv.org/abs/2603.15777}, 
}`)
                    setCopied(true)
                    setTimeout(() => setCopied(false), 1200)
                  }}
                >
                  {copied ? "Copied!" : "BibTeX"}
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

    </section>
  )
}

const Editrail = () => {
  const [copied, setCopied] = useState(false)
  return (
    <section className='whole_section'>
      <section className="section-row">
        <div className="section-left">
          <div className="section-image">
            <img src={editrail_photo} alt="Editrail" />
          </div>
        </div>
        <div className="section-right">
          <div>
            <div className="section-title-large">
              <p className="section-position">
                In Submission</p>
              <p className="section-title">
                <strong>Editrail</strong>: Understanding AI Usage by Visualizing Student-AI Interaction in Code
              </p>
              <p className="section-author">
                Ashley Ge Zhang, Yan-Ru Jhou, <span style={{
                  fontWeight: '600'
                }}>Yinuo Yang</span>, Shamita Rao, Maryam Arab, Yan Chen, Steve Oney</p>
            </div>
            <div className="read-more-card-mobile">
              <div className="card-closed">
                <a className="card" href={editrail_paper} target='_blank'>Paper</a>
                {/* <a href="https://inonnno.github.io/Academic-project-page-Spark/" target='_blank' className="card" >Project</a>
                <a href="https://peachlab.inf.ethz.ch/projects/spark/" target='_blank' className="card" >Website</a> */}
                <a href="https://doi.org/10.48550/arXiv.2601.20085" target='_blank' className="card" >Arxiv</a>
                {/* <a className="card" href={spart_preprint} target='_blank'>Preprint</a> */}
                {/* <span className="card" >Demo</span> */}
                <span
                  className="card"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigator.clipboard.writeText(`@article{zhang2026editrail,
  title={Editrail: Understanding AI Usage by Visualizing Student-AI Interaction in Code},
  author={Zhang, Ashley Ge and Jhou, Yan-Ru and Yang, Yinuo and Rao, Shamita and Arab, Maryam and Chen, Yan and Oney, Steve},
  journal={arXiv preprint arXiv:2601.20085},
  year={2026}
}`)
                    setCopied(true)
                    setTimeout(() => setCopied(false), 1200)
                  }}
                >
                  {copied ? "Copied!" : "BibTeX"}
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

    </section>
  )
}



const SPARK = () => {
  const [copied, setCopied] = useState(false)
  return (
    <section className='whole_section'>
      <section className="section-row">
        <div className="section-left">
          <div className="section-image">
            <img src={spark_photo} alt="spark" />
          </div>
        </div>
        <div className="section-right">
          <div>
            <div className="section-title-large">
              <p className="section-position">
                VL/HCC'25: IEEE Symposium on Visual Languages and Human-Centric Computing</p>
              <p className="section-title">
                <strong>SPARK</strong>: Real-Time Monitoring of Multi-Faceted Programming Exercises
              </p>
              <p className="section-author">
                <span style={{
                  fontWeight: '600'
                }}>Yinuo Yang</span>, Ashley Ge Zhang, Steve Oney, April Yi Wang</p>
            </div>
            <div className="read-more-card-mobile">
              <div className="card-closed">
                <a className="card" href={spark_paper} target='_blank'>Paper</a>
                <a href="https://inonnno.github.io/Academic-project-page-Spark/" target='_blank' className="card" >Project</a>
                <a href="https://peachlab.inf.ethz.ch/projects/spark/" target='_blank' className="card" >Website</a>
                <a href="https://ieeexplore.ieee.org/document/11303487" target='_blank' className="card" >DOI</a>
                {/* <a className="card" href={spart_preprint} target='_blank'>Preprint</a> */}
                {/* <span className="card" >Demo</span> */}
                <span
                  className="card"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigator.clipboard.writeText(`@inproceedings{yang2025spark,
  title={SPARK: Real-Time Monitoring of Multi-Faceted Programming Exercises},
  author={Yang, Yinuo and Zhang, Ashley Ge and Oney, Steve and Wang, April Yi},
  booktitle={2025 IEEE Symposium on Visual Languages and Human-Centric Computing (VL/HCC)},
  pages={81--92},
  year={2025},
  organization={IEEE}
}`)
                    setCopied(true)
                    setTimeout(() => setCopied(false), 1200)
                  }}
                >
                  {copied ? "Copied!" : "BibTeX"}
                </span>
              </div>
            </div>
            <div className='award'
            >
              <svg
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                shapeRendering="geometricPrecision"
                viewBox="2 0 24 24"
                height="16"
                width="16"
                style={{ color: "currentColor" }}
              >
                <circle cx="12" cy="8" r="7"></circle>
                <path d="M8.21 13.89L7 23l5-3 5 3-1.21-9.12"></path>
              </svg> &nbsp;
              <span> Honorable Mention Award </span></div>
          </div>
        </div>
      </section>

    </section>
  )
}

const GLITTER = () => {
  const [copied, setCopied] = useState(false)
  return (
    <section className='whole_section'>
      <section className="section-row">
        <div className="section-left">
          <div className="section-image">
            <img src={glitter_photo} alt="glitter" />
          </div>
        </div>
        <div className="section-right">
          <div>
            <div className="section-title-large">
              <p className="section-position">
                UIST'25: Proceedings of the ACM Symposium on User Interface Software and Technology</p>
              <p className="section-title">
                <strong>Glitter:</strong> An AI-assisted Platform for Material-Grounded
                Asynchronous Discussion in Flipped Learning
              </p>
              <p className="section-author">
                Weirui Peng*, <span style={{
                  fontWeight: '600'
                }}>Yinuo Yang*</span>, Zheng Zhang, Toby Jia-Jun Li</p>
            </div>
            <div className="read-more-card-mobile">
              <div className="card-closed">
                <a className="card" href={glitter_paper} target='_blank'>Paper</a>
                {/* <a className="card" href='https://arxiv.org/abs/2504.14695' target='_blank'>Arxiv</a> */}
                {/* <span className="card" >Demo</span> */}
                <a className="card" href=' https://doi.org/10.1145/3746059.3747742' target='_blank'>DOI</a>

                <span
                  className="card"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigator.clipboard.writeText(`@inproceedings{peng2025glitter,
  title={Glitter: An ai-assisted platform for material-grounded asynchronous discussion in flipped learning},
  author={Peng, Weirui and Yang, Yinuo and Zhang, Zheng and Li, Toby Jia-Jun},
  booktitle={Proceedings of the 38th Annual ACM Symposium on User Interface Software and Technology},
  pages={1--22},
  year={2025}
}`)
                    setCopied(true)
                    setTimeout(() => setCopied(false), 1200)
                  }}
                >
                  {copied ? "Copied!" : "BibTeX"}
                </span>

              </div>
            </div>
          </div>
        </div>
      </section>

    </section>
  )
}

// const SPARK = () => {
//   return (
//     <section className='whole_section'>
//       <section className="section-row">
//         <div className="section-left">
//           <div className="section-image">
//             {/* <a href={VizCode} target='_blank'> */}
//             <img src={spark_photo} alt="spark" />
//             {/* </a> */}
//           </div>
//         </div>
//         <div className="section-right">
//           <div>
//             <div className="section-title-large">
//               <h2 className="section-title">
//                 SPARK: Real-Time Monitoring of Multi-Faceted Programming Exercises
//                 {/* <a href={spart_preprint} target='_blank' className='pdf'>
//                   &nbsp; &nbsp;Preprint
//                 </a> */}
//               </h2>
//               <p className="section-author">
//                 <span style={{
//                   fontWeight: '600'
//                 }}>Yinuo Yang</span>, Ashley Ge Zhang, Steve Oney, April Yi Wang</p>
//               <p className="section-position">
//                 In Submission</p>
//             </div>
//             <div className="read-more-card-mobile">
//               <div className="card-closed">
//                 <p>
//                   Proposed SPARK, a system that enables instructors to specify
//                   decomposed programming tasks with LLM-assisted test case creation,
//                   providing interpretive visualizations of students’ real-time progress
//                   and workflows. SPARK also supports real-time inspection of
//                   intermediate outputs, offering instructors customized insights
//                   into students' programming states.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//     </section>
//   )
// }
const VizCode_demo = () => {
  const [copied, setCopied] = useState(false)
  return (
    <section className='whole_section'>
      <section className="section-row">
        <div className="section-left">
          <div className="section-image">
            <img src={VizCode_demo_photo} alt="telemetry" />
          </div>
        </div>
        <div className="section-right">
          <div>
            <div className="section-title-large">
              <p className="section-position">
                L@S'24 Demo</p>
              <p className="section-title">
                <strong>VizCode</strong>: A Practical Real-time Tool for In-Class Computer Programming Tutoring
              </p>
              <p className="section-author">
                <span style={{
                  fontWeight: '600'
                }}>Yinuo Yang</span>, Steve Oney</p>
            </div>
            <div className="read-more-card-mobile">
              <div className="card-closed">
                <a className="card" href={VizCode} target='_blank'>Paper</a>
                <a className="card" href='https://doi.org/10.1145/3657604.3664716' target='_blank'>DOI</a>
                <a className="card" href='https://marketplace.visualstudio.com/items?itemName=educational-technology-collective.telemetry' target='_blank'>Website</a>
                <span
                  className="card"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigator.clipboard.writeText(`@inproceedings{yang2024vizcode,
  title={Vizcode: A practical real-time tool for in-class computer programming tutoring},
  author={Yang, Yinuo and Oney, Steve},
  booktitle={Proceedings of the Eleventh ACM Conference on Learning@ Scale},
  pages={544--546},
  year={2024}
}`)
                    setCopied(true)
                    setTimeout(() => setCopied(false), 1200)
                  }}
                >
                  {copied ? "Copied!" : "BibTeX"}
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section >
  )
}
const Protea_workshop = () => {
  return (
    <section className='whole_section'>
      <section className="section-row">
        <div className="section-left">
          <div className="section-image">
            <img src={protea_photo} alt="protea" />
          </div>
        </div>
        <div className="section-right">
          <div>
            <div className="section-title-large">
              <p className="section-position">
                CHI 2025 Workshop</p>
              <p className="section-title">
                Understanding And Guiding Student-AI Interaction In Future
                Programming Education
              </p>
              <p className="section-author">
                <span style={{
                  fontWeight: '600'
                }}>Yinuo Yang</span>, Steve Oney</p>
            </div>
            <div className="read-more-card-mobile">
              <div className="card-closed">
                {/* <a className="card" href='' target='_blank'>DOI</a> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </section >
  )
}
// const VizCode_demo = () => {
//   return (
//     <section className='whole_section'>
//       <section className="section-row">
//         <div className="section-left">
//           <div className="section-image">
//             <a href={VizCode} target='_blank'>
//               <img src={VizCode_demo_photo} alt="telemetry" />
//             </a>
//           </div>
//         </div>
//         <div className="section-right">
//           <div>
//             <div className="section-title-large">
//               <h2 className="section-title">
//                 VizCode: A Practical Real-time Tool for In-Class Computer Programming Tutoring
//                 <a href={VizCode} target='_blank' className='pdf'>
//                   &nbsp; &nbsp;PDF
//                 </a>
//               </h2>
//               <p className="section-author">
//                 <span style={{
//                   fontWeight: '600'
//                 }}>Yinuo Yang</span>, Steve Oney</p>
//               <p className="section-position">Demonstration, In Proceedings of the Eleventh ACM
//                 Conference on Learning @ Scale (L@S ’24)</p>
//             </div>
//             <div className="read-more-card-mobile">
//               <div className="card-closed">
//                 <p>
//                   This demonstration showcases VizCode, a tool that allows instructors to monitor
//                   students’ code in real-time as they edit in the popular Visual Studio
//                   Code (VSCode) IDE.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//     </section>
//   )
// }
const NDU = () => {
  return (
    <section className='whole_section' id='ndu'>
      <section className="section-row">
        <div className="section-left-research">
          {/* <div className="section-image">
            <a href="https://marketplace.visualstudio.com/items?itemName=educational-technology-collective.telemetry" target="_blank" rel="noopener noreferrer">
              <img src={telemetryphoto} alt="telemetry" />
            </a>
          </div> */}
          <p>May 2024
            - Now</p>
        </div>
        <div className="section-right-research">

          <div>
            <div className="section-title-large">
              <h2 className="section-title"> Summer Visiting Researcher</h2>
              <p className="section-position">SaNDwich Lab, University of Notre Dame</p>
            </div>
            <div className="read-more-card-mobile">
              <div className="card-closed">
                <p style={{ textDecoration: 'underline' }}> </p>
                <p className="advisor">Advisor: Prof. Toby Jia-Jun Li</p>
                <p>
                  <li style={{ paddingLeft: '1.5em', textIndent: '-1.5em' }}>
                    Co-led a project leveraging LLMs and visual representations to scaffold student navigation of discussion spaces, applying Conceptual Blending Theory
                    to encourage broader content engagement, enabling dynamic exploration of
                    content during the self-learning phase of flipped classrooms.
                  </li>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  )
}
const Spot = () => {
  return (
    <section className='whole_section' id='spot'>
      <section className="section-row">
        <div className="section-left-research">
          {/* <div className="section-image">
            <a href="https://marketplace.visualstudio.com/items?itemName=educational-technology-collective.telemetry" target="_blank" rel="noopener noreferrer">
              <img src={telemetryphoto} alt="telemetry" />
            </a>
          </div> */}
          <p>Sept 2023
            - Now</p>
        </div>
        <div className="section-right-research">

          <div>
            <div className="section-title-large">
              <h2 className="section-title"> Undergraduate Research Assistant</h2>
              <p className="section-position">Spot Lab, University of Michigan</p>
            </div>
            <div className="read-more-card-mobile">
              <div className="card-closed">
                {/* <p style={{ display: 'flex' }}>
                  <p style={{ textDecoration: 'underline' }}>
                    Live Visualizations of Students’ Code‑writing Processes
                  </p>
                </p> */}
                <p className="advisor">Advisors: Prof. Steve Oney and Prof. April Yi Wang</p>
                <p>
                  <li style={{ paddingLeft: '1.5em', textIndent: '-1.5em' }}>
                    Led the <span style={{ fontWeight: '500', fontStyle: 'italic' }}>SPARK</span> project, which introduced a
                    system that allows customizable visualization and inspection of students'
                    code-writing progress, workflows, and states for multi-faceted programming exercises.
                  </li>
                  <li style={{ paddingLeft: '1.5em', textIndent: '-1.5em' }}>
                    Conducted a 16-participant within-subject user study, showing that <span style={{ fontWeight: '500', fontStyle: 'italic' }}>SPARK</span> deepens instructors' understanding of students’
                    programming progress and promotes active engagement in monitoring.
                  </li>
                  <li style={{ paddingLeft: '1.5em', textIndent: '-1.5em' }}>
                    Developed <span style={{ fontWeight: '500', fontStyle: 'italic' }}>VizCode</span> and created a dataset using it that captures students' real-time, keystroke-level
                    programming behaviors,
                    providing detailed insights into their problem-solving strategies and trajectories.
                  </li>
                </p>
                {/* <p>
                  VizCode integrates seamlessly into VSCode by a VSCode extension
                  <a href="https://marketplace.visualstudio.com/items?itemName=educational-technology-collective.telemetry" target="_blank" className='pdf' rel="noopener noreferrer">
                    &nbsp;Telemetry
                  </a>, a data server and a web-based dashboard
                  , offering
                  instructors a practical and
                  scalable solution to oversee coding
                  practices in large programming classes.
                </p> */}
                {/* <p>
                  We are currently working on using Large Language Model (LLM) to assist in teaching
                  and to create better visualizations of students' code-writing progress.
                </p> */}
              </div>
            </div>
            {/* <div>
              <p style={{ textDecoration: 'underline' }}>Puzzlemi in JupyterLab</p>
              <p className="advisor">Advisor: Dr. April Yi Wang</p>
              <p>
                Explore migrating the interactive program PuzzleMe from a website to JupyterLab Document using Redux and Yjs.
              </p>
            </div> */}

          </div>
        </div>
      </section>
    </section >
  )
}
const MusicApp = () => {
  return (
    <section className='whole_section'>
      <section className="section-row">
        <div className="section-left">
          <div className="section-image">
            <a href={music_app_design} target='_blank'>
              <img src={m2} alt="telemetry" />
            </a>
          </div>
        </div>
        <div className="section-right">
          <div>
            <div className="section-title-large">
              <h2 className="section-title">
                User-friendly Music Sharing App Design
                <a href={music_app_design} target='_blank' className='pdf'>
                  &nbsp; &nbsp;PDF
                </a>
              </h2>
              <p className="section-position">University of Michigan, UMSI</p>
            </div>
            <div className="read-more-card-mobile">
              <div className="card-closed">
                <p>
                  Design a user-friendly music-sharing app using Figma for everyone to share songs and music clips.
                </p>
                <p>
                  Ensure accessibility by sound wave visualization for users with hearing impairments or those in noisy environments.
                </p>

              </div>
            </div>
          </div>
        </div>
      </section>

    </section>
  )
}
// const Puzzlemi_JupyterLab = () => {
//   return (
//     <section className='whole_section'>
//       <section className="section-row">
//         <div className="section-left">
//           <div className="section-image">
//             <img src={Puzzle} alt="telemetry" />
//           </div>
//         </div>
//         <div className="section-right">
//           <div>
//             <div className="section-title-large">
//               <h2 className="section-title">
//                 Puzzlemi in JupyterLab
//               </h2>
//               <p className="section-position">University of Michigan, Advised by Dr. April Yi Wang</p>
//             </div>
//             <div className="read-more-card-mobile">
//               <div className="card-closed">
//                 <p>
//                   Explore migrating the interactive program PuzzleMe from a website to JupyterLab Document using Redux and Yjs.
//                 </p>
//                 <p>
//                   Explore to use Redux and Yjs within JupyterLab Extension.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>

//       </section>

//     </section>
//   )
// }
const Searching_ChatGPT = () => {
  return (
    <section className='whole_section'>
      <section className="section-row">
        <div className="section-left">
          <div className="section-image">
            <a href={Searching_Behaviors} target='_blank'>
              <img src={journeymap} alt="telemetry" />
            </a>
          </div>
        </div>
        <div className="section-right">
          <div>
            <div className="section-title-large">
              <h2 className="section-title">
                Understanding Different Types of Programmers’ Searching Behaviors with ChatGPT
                <a href={Searching_Behaviors} target='_blank' className='pdf'>
                  &nbsp; &nbsp;PDF
                </a>
              </h2>
              <p className="section-position">University of Michigan, UMSI</p>
            </div>
            <div className="read-more-card-mobile">
              <div className="card-closed">
                <p>
                  Research and analyze the search
                  behaviors of programmers with many searching platforms, especially in ChatGPT.
                </p>
                <p>
                  We find that programmers increasingly rely on ChatGPT
                  for resource acquisition.
                  However, due to information randomness,
                  information credibility, and the limitations of
                  ChatGPT capabilities, they still cannot fully depend on it.
                </p>
              </div>
            </div>
          </div>
        </div>

      </section>

    </section>
  )
}
const MondrianCats = () => {
  return (
    <section className='whole_section'>
      <section className="section-row">
        <div className="section-left">
          <div className="section-image">
            <a href='https://inonnno.github.io/Cats-in-Mondrian/' target='_blank'>
              <img src={Mondrian} alt="telemetry" />
            </a>
          </div>
        </div>
        <div className="section-right">
          <div>
            <div className="section-title-large">
              <h2 className="section-title">
                AI-Generated Cats in Mondrian Universe
                <a href='https://inonnno.github.io/Cats-in-Mondrian/' target='_blank' className='pdf'>
                  &nbsp; &nbsp;DEMO
                </a>
              </h2>
              <p className="section-position">University of Michigan</p>
            </div>
            <div className="read-more-card-mobile">
              <div className="card-closed">
                <p>
                  This work is inspired by Mondrian's style and incorporates AI-generated cat silhouettes,
                  powered by p5.js.
                </p>
                <p>
                  The cat silhouettes are generated by OpenAI ChatGPT-4,
                  and the lines and color blocks in the artwork are randomly generated with code.
                </p>

              </div>
            </div>
          </div>
        </div>
      </section>

    </section>
  )
}
const Dataset_webProgramming = () => {
  return (
    <section className='whole_section'>
      <section className="section-row">
        <div className="section-left">
          <div className="section-image">
            <a href="https://github.com/inonnno/Dataset_WebProg" target='_blank'>
              <img src={datasetWebprog} alt="telemetry" />
            </a>
          </div>
        </div>
        <div className="section-right">
          <div>
            <div className="section-title-large">
              <h2 className="section-title">
                Keystroke Coding Dataset for Web Programming
                {/* <a href='https://github.com/inonnno/Dataset_WebProg' target='_blank' className='pdf'>
                  &nbsp; &nbsp;Github
                </a> */}
                <a href='https://osf.io/nwjq3/?view_only=e3c1d102669d4d1793d7ce7fb34cb35d' target='_blank' className='pdf'>
                  &nbsp; &nbsp;OSF
                </a>
              </h2>
              <p className="section-position">University of Michigan, Spot Lab</p>
            </div>
            <div className="read-more-card-mobile">
              <div className="card-closed">
                <p>
                  This dataset captures students' real-time, keystroke-level programming
                  behaviors to provide insights into their problem-solving strategies and trajectories,
                  bridging the gap in traditional code datasets that lack detailed granularity-level information.
                </p>

              </div>
            </div>
          </div>
        </div>
      </section>

    </section>
  )
}
export { Oversight, VISAR_Deploy, GLITTER, CodeStream, Editrail, Protea_workshop, Spot, MusicApp, Searching_ChatGPT, MondrianCats, NDU, VizCode_demo, SPARK, Dataset_webProgramming }